import React from "react";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { handlePatchCalendarEvent } from "./CalendarsUtils/handlePatchCalendarEvent";
import { AddEventDialog } from "./AddEventDialog";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag";

export const EditEventDialog = ({
  patchEvent,
  editEventDialogOpen,
  setEditEventDialogOpen,
  setEditingCalendar,
  setCalendarEvents,
  navigate,
}: {
  patchEvent: any;
  editEventDialogOpen: boolean;
  setEditEventDialogOpen: Dispatcher<boolean>;
  setEditingCalendar: Dispatcher<boolean>;
  setCalendarEvents: any;
  navigate: NavigateFunction;
}) => {
  const { isFeatureEnabled } = useFeatureFlag();
  const showAddCalendarScheduleTime = isFeatureEnabled(
    "showAddCalendarScheduleTime",
    false
  );

  const initialEvent = React.useMemo(
    () => ({
      event_date: patchEvent.event_date,
      name: patchEvent.name,
      start_time: patchEvent.start_time ?? null,
      end_time: patchEvent.end_time ?? null,
    }),
    [
      patchEvent.event_date,
      patchEvent.name,
      patchEvent.start_time,
      patchEvent.end_time,
    ]
  );

  return (
    <AddEventDialog
      open={editEventDialogOpen}
      title="Edit Event"
      submitLabel="Save"
      requireChanges
      initialEvent={initialEvent}
      showScheduleTime={showAddCalendarScheduleTime}
      onCancel={() => {
        setEditEventDialogOpen(false);
        setEditingCalendar(false);
      }}
      onSubmit={(updatedEvent) => {
        setEditEventDialogOpen(false);
        setEditingCalendar(true);
        handlePatchCalendarEvent(
          {
            ...patchEvent,
            ...updatedEvent,
          },
          setCalendarEvents,
          setEditingCalendar,
          navigate
        );
      }}
    />
  );
};
